import React from "react";
import { Col, Row } from "react-bootstrap";

const PrimeraCita = ({ data, esHombre }) => {
  const timestamp = data._id.toString().substring(0, 8);
  const date = new Date(parseInt(timestamp, 16) * 1000);

  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Registro de la primera cita</h3>
          <p className="text-muted">{date.toString()}</p>
        </Col>
      </Row>

      <Row>
        <Col lg={6}>
          <dl>
            <dt className="all-caps">Motivo de consulta</dt>
            <dd>{data.motivo}</dd>

            <dt className="all-caps">Enfermedad actual</dt>
            <dd>{data.enfermedad}</dd>

            <dt>Tipo de sangre</dt>
            <dd>{data.sangre}</dd>

            <dt className="all-caps">Revisión por sistemas</dt>
            <dd>
              <dl style={{ textIndent: "10%" }}>
                {data.revisionSistemas.map((sistema) => {
                  if (!sistema.detalle) return null;
                  return (
                    <React.Fragment key={sistema.sistema}>
                      <dt>{sistema.sistema}</dt>
                      <dd>{sistema.detalle}</dd>
                    </React.Fragment>
                  );
                })}
              </dl>
            </dd>
          </dl>
        </Col>

        <Col lg={6}>
          <dl>
            <dt className="all-caps">Antecedentes personales</dt>
            <dd>
              <dl style={{ textIndent: "10%" }}>
                {data.antecedentesPer.map((antecedente) => (
                  <React.Fragment key={antecedente.antecedente}>
                    <dt>{antecedente.antecedente}</dt>
                    <dd>{antecedente.detalle}</dd>
                  </React.Fragment>
                ))}
              </dl>
            </dd>

            <dt className="all-caps">Antecedentes familiares</dt>
            <dd>{data.antecedentesFam}</dd>

            <dt>Vacunas</dt>
            <dd>{data.vacunas}</dd>
          </dl>
        </Col>
      </Row>

      {!esHombre && (
        <Row>
          <Col>
            <dl>
              <dt>Ginecología</dt>
              <dd>
                <dl style={{ textIndent: "10%" }}>
                  <Row>
                    <Col>
                      <dt>Embarazos</dt>
                      <dd>{data.ginecologia[0].embarazos}</dd>
                    </Col>
                    <Col>
                      <dt>Partos</dt>
                      <dd>{data.ginecologia[0].partos}</dd>
                    </Col>
                    <Col>
                      <dt>Cesáreas</dt>
                      <dd>{data.ginecologia[0].cesareas}</dd>
                    </Col>
                    <Col>
                      <dt>Abortos</dt>
                      <dd>{data.ginecologia[0].abortos}</dd>
                    </Col>
                  </Row>

                  <dt>Planificación</dt>
                  <dd>{data.ginecologia[0].planificacion}</dd>

                  <dt>Menarquia</dt>
                  <dd>{data.ginecologia[0].menarquia}</dd>

                  <dt>Ciclos</dt>
                  <dd>{data.ginecologia[0].ciclos}</dd>

                  <dt>Citología</dt>
                  <dd>{data.ginecologia[0].citologia}</dd>

                  <dt>Mamografía</dt>
                  <dd>{data.ginecologia[0].mamografia}</dd>
                </dl>
              </dd>
            </dl>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <dl>
            <dt className="all-caps">Examen físico por sistemas</dt>
          </dl>
          {data.examenSistemas.map(({ sistema, detalle }) => {
            if (sistema !== "general") {
              return (
                <Row key={sistema}>
                  <Col
                    xs={{ offset: 1, span: 11 }}
                    style={{ fontWeight: "bold" }}
                  >
                    {sistema}
                  </Col>
                  <Col xs={{ offset: 2 }}>{detalle}</Col>
                </Row>
              );
            } else {
              return (
                <div className="no-wrap" key={sistema}>
                  <Row>
                    <Col
                      xs={{ offset: 1, span: 11 }}
                      style={{ fontWeight: "bold" }}
                    >
                      {sistema}
                    </Col>
                  </Row>

                  {detalle.estado && (
                    <Row>
                      <Col
                        xs={{ offset: 2, span: 10 }}
                        style={{ fontWeight: "bold" }}
                      >
                        Estado general
                      </Col>
                      <Col xs={{ offset: 2, span: 10 }}>{detalle.estado}</Col>
                    </Row>
                  )}

                  <Row>
                    <Col xs={{ offset: 2 }} style={{ fontWeight: "bold" }}>
                      Peso
                    </Col>
                    <Col>{detalle.peso} kilogramos</Col>
                  </Row>

                  <Row>
                    <Col xs={{ offset: 2 }} style={{ fontWeight: "bold" }}>
                      Talla
                    </Col>
                    <Col>{detalle.talla} metros</Col>
                  </Row>

                  <Row>
                    <Col xs={{ offset: 2 }} style={{ fontWeight: "bold" }}>
                      Índice de masa corporal
                    </Col>
                    <Col>{Math.round(detalle.imc * 100) / 100}</Col>
                  </Row>

                  {detalle.tension && (
                    <Row>
                      <Col xs={{ offset: 1 }} style={{ fontWeight: "bold" }}>
                        Tensión
                      </Col>
                      <Col>{detalle.tension} mm de Hg.</Col>
                    </Row>
                  )}

                  {detalle.frecCardiaca && (
                    <Row>
                      <Col xs={{ offset: 1 }} style={{ fontWeight: "bold" }}>
                        Frecuencia cardiaca
                      </Col>
                      <Col>{detalle.frecCardiaca} pulsaciones/minuto</Col>
                    </Row>
                  )}

                  {detalle.frecRespiratoria && (
                    <Row>
                      <Col xs={{ offset: 1 }} style={{ fontWeight: "bold" }}>
                        Frecuencia respiratoria
                      </Col>
                      <Col>{detalle.frecRespiratoria} respiraciones/minuto</Col>
                    </Row>
                  )}

                  {detalle.temperatura && (
                    <Row>
                      <Col xs={{ offset: 1 }} style={{ fontWeight: "bold" }}>
                        Temperatura
                      </Col>
                      <Col>{detalle.temperatura} °C</Col>
                    </Row>
                  )}

                  {detalle.pulso && (
                    <Row>
                      <Col xs={{ offset: 1 }} style={{ fontWeight: "bold" }}>
                        Pulso
                      </Col>
                      <Col>{detalle.pulso}</Col>
                    </Row>
                  )}

                  {detalle.lengua && (
                    <Row>
                      <Col
                        xs={{ offset: 1, span: 11 }}
                        style={{ fontWeight: "bold" }}
                      >
                        Lengua
                      </Col>
                      <Col xs={{ offset: 2 }}>{detalle.lengua}</Col>
                    </Row>
                  )}

                  {detalle.tez && (
                    <Row>
                      <Col
                        xs={{ offset: 1, span: 11 }}
                        style={{ fontWeight: "bold" }}
                      >
                        Tez
                      </Col>
                      <Col xs={{ offset: 2 }}>{detalle.tez}</Col>
                    </Row>
                  )}
                </div>
              );
            }
          })}
        </Col>
      </Row>

      <Row>
        <Col>
          <dl>
            <dt>Examen energético</dt>
            <dd>{data.examenEnergetico}</dd>
          </dl>
        </Col>
      </Row>

      <Row>
        <Col>
          <dl>
            <dt>Diagnóstico</dt>
            <dd>{data.diagnostico}</dd>
          </dl>
        </Col>
      </Row>

      <Row>
        <Col>
          <dl>
            <dt>Plan y tratamiento</dt>
            <dd>{data.tratamiento}</dd>
          </dl>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default PrimeraCita;
